import type { UiSchema } from "@rjsf/utils";
import type { CustomFunctionUserInputPresentation } from "src/api/generated/erp/customFunctions/model/customFunctionUserInputPresentation.ts";

const TEXTAREA_MIN_ROWS = 3;

export function createCustomFunctionUserInputUiSchema(
	presentations: Record<string, CustomFunctionUserInputPresentation>,
): UiSchema {
	return Object.fromEntries(
		Object.entries(presentations).map(([inputField, presentation]) => {
			switch (presentation.control) {
				case "TEXTAREA":
					return [
						inputField,
						{
							"ui:widget": "textarea",
							"ui:options": { rows: TEXTAREA_MIN_ROWS },
						},
					];
			}
		}),
	);
}
